import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=6b67923c&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"
import style0 from "./Resume.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Resume.vue?vue&type=style&index=1&id=6b67923c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67923c",
  null
  
)

export default component.exports